import React from 'react';
import { THEMES } from '../../utils/constants';

export const SectionHeader = ({ icon: Icon, title, subtitle, element = 'air' }) => {
    const theme = THEMES[element] || THEMES['air'];
    return (
        <div className="flex items-start gap-3 mb-6">
            <div className={`p-2 rounded-lg shrink-0 ${theme.bg} border ${theme.border}`}>
                <Icon className={`w-5 h-5 text-${theme.tailwind}`} />
            </div>
            <div>
                <h3 className="text-lg font-semibold text-slate-100">{title}</h3>
                <p className="text-sm text-slate-400">{subtitle}</p>
            </div>
        </div>
    );
};